<template>
    <div class="animated fadeIn">
        <div class="card">
            <div class="card-header main-card-header">
                <span>Additional test list</span>
                <div class="card-header-actions"></div>
            </div>
            <div class="card-body main-card-body">
                <div class="text-left">
                    <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
                        <b-card>
                            <el-form
                                ref="myForm"
                                label-position="top"
                                @submit.native.prevent
                                :model="mData.tableRules.dataSearch.value"
                                :rules="mData.tableRules.dataSearch.valid"
                            >
                                <b-row>
                                    <b-col md="3">
                                        <el-form-item label="Họ tên" prop="">
                                            <el-input v-model="mData.tableRules.dataSearch.value['ho_chieu.ho_ten']" clearable></el-input>
                                        </el-form-item>
                                    </b-col>
                                    <b-col md="3">
                                        <el-form-item label="Số hộ chiếu" prop="">
                                            <el-input v-model="mData.tableRules.dataSearch.value['ho_chieu.so_ho_chieu']" clearable></el-input>
                                        </el-form-item>
                                    </b-col>
                                    <b-col md="3">
                                        <el-form-item label="Quốc tịch" prop="">
                                            <el-select
                                                v-model="
                                                    mData.tableRules.dataSearch.value['ho_chieu.quoc_tich_id']
                                                "
                                                :placeholder="aLang.c_select"
                                                clearable
                                                filterable
                                            >
                                                <el-option
                                                    v-for="item in mData.dataDefault.listQuocGia"
                                                    :key="item.id"
                                                    :label="item.ten_quoc_tich.vi"
                                                    :value="item.id"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </b-col>
                                </b-row>
                                <el-form-item class="text-center mb-0">
                                    <el-button
                                        type="info"
                                        native-type="submit"
                                        v-ladda
                                        plain
                                        @click="fn_tableSearch()"
                                    >{{aLang.c_search}}</el-button>
                                </el-form-item>
                            </el-form>
                        </b-card>
                    </b-collapse>
                </div>
                <b-row>
                    <b-col md="8" class="p-0">
                        <b-col md="4"></b-col>
                    </b-col>
                    <b-col md="4">
                        <div class="text-right mb-2">
                            <el-button
                                @click="fn_tableShowFormSearch()"
                                type="info"
                                plain
                            >{{aLang.c_showHideSearch}}</el-button>
                        </div>
                    </b-col>
                </b-row>
                <div class="mt-1">
                    <div class="mt-4" v-if="haveNoData">
                        <h4 class="d-flex justify-content-center" style="flex-direction: column; align-items: center;">Hiện tại chưa có xét nghiệm bổ sung nào</h4>
                    </div>
                    <b-row class="mb-4" v-if="!haveNoData">
                        <b-col class="mb-2" xl="4" md="6" v-for="(item,index) of mData.data" :key="item.id">
                            <el-collapse v-model="activeNames" >
                                <el-collapse-item :name="index">
                                    <template slot="title">
                                        {{item.ho_ten}} -  
                                        {{item.so_ho_chieu}}
                                    </template>
                                    <b-row>
                                        <b-col md="5" class="qr">
                                            <div class="text-center">
                                                <el-image 
                                                    style="height: 50%"
                                                    :src="imgUrl+item.anh_chan_dung_id" 
                                                    fit="contain"
                                                >
                                                </el-image>
                                            </div>
                                        </b-col>
                                        <b-col class="mb-5" md="7">
                                            <p> 
                                                <span class="title-list">Họ tên: </span>
                                                <span class="infomation">{{item.ho_ten}}</span>
                                            </p>
                                            <p> 
                                                <span class="title-list">Số hộ chiếu: </span>
                                                <span class="infomation">{{item.so_ho_chieu}}</span>
                                            </p>
                                            <p> 
                                                <span class="title-list">Quốc tịch: </span>
                                                <span class="infomation">{{item.quoc_tich}}</span>
                                            </p>
                                        </b-col>
                                        <div style="position: absolute;right: 25px;bottom: 10px;">
                                            <el-button icon="el-icon-info" round @click="fn_handle('approve',item.id)">Chi tiết</el-button>
                                        </div>
                                    </b-row>
                                </el-collapse-item>
                            </el-collapse>
                        </b-col>
                    </b-row>
                </div>
                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                    <div class="col-md-4">
                        <div
                            v-if="mData.tableRules.allowSelect"
                        >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
                        </div>
                    <div class="col-md-8 text-right">
                        <el-pagination
                            @size-change="fn_tableSizeChange"
                            @current-change="fn_tableCurentChange"
                            @prev-click="fn_tablePrevClick"
                            @next-click="fn_tableNextClick"
                            :page-sizes="mData.tableRules.lengthMenu"
                            :page-size="mData.tableRules.limit"
                            :current-page="mData.tableRules.page"
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="mData.tableRules.total"
                            :pager-count="5"
                        ></el-pagination>
                    </div>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import ForeignerApi from '../../../moduleApi/ForeignerApi';
import QuocGiaApi from '../../../moduleApi/QuocGiaApi';
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from '../../../service/ExtensionService';
import ValidService from '../../../service/ValidService';
import * as moment from 'moment';

export default {
    filters: {
        dateFormat: function (value) {
            let format = "DD/MM/YYYY";
            if (!value) return ''
            return moment(value).format(format);
        }
    },
    data() {
        return {
            aLang: LanguageService.lang,
            aElement: MethodService.element,
            activeNames: '',
            imgUrl: ExtensionService.urlImg,
            mData: {
                moduleName: "ListTestCertificate",
                data: [],
                dataDefault: {
                    listQuocGia: [],
                    listForeigner: [],
                },
                tableRules: {
                    lengthMenu: [20, 50, 100],
                    allowPaging: true,
                    allowSorting: true,
                    allowSelect: false,
                    showFormSearch: false,
                    showUrl: true,
                    total: 0,
                    page: 1,
                    limit: 20,
                    offset: 0,
                    sort: "",
                    filters:"",
                    filtersForeigner: "",
                    dataSearch: {
                        value: {
                            "ho_chieu.ho_ten": "",
                            "ho_chieu.so_ho_chieu": "",
                            "ho_chieu.quoc_tich_id": ""
                        },
                        valid: {
                            "ho_chieu.ho_ten": [],
                            "ho_chieu.so_ho_chieu": [],
                            "ho_chieu.quoc_tich_id": []
                        },
                        operator: {
                            "ho_chieu.ho_ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
                            "ho_chieu.so_ho_chieu": ":regex_i:",
                            "ho_chieu.quoc_tich_id": ""
                        }
                    }
                }
            },
            haveNoData: false
        };
    },
    methods: {
        async fn_initData(){
            console.log("quoc_tich",this.mData.tableRules.dataSearch.value.quoc_tich);
            let quocGiaRes = await QuocGiaApi.list();
            this.mData.dataDefault.listQuocGia = quocGiaRes.result;
            let vietNam = this.mData.dataDefault.listQuocGia.find(maQG => maQG.ma.alpha_2 == "VN");
            let dataFilter = {
                filters: this.mData.tableRules.filters + 
                ( this.mData.tableRules.filters ? "&" : "" )+ "trang_thai:in:cho_nhap_visa,cho_nhap_canh,da_nhap_canh&xet_nghiem:elemMatch:duoc_duyet:is_null:true,anh_id:is_null:false,quoc_gia_id!="+vietNam.id
            };
            if (this.mData.tableRules.allowPaging) {
                dataFilter.limit = this.mData.tableRules.limit;
                dataFilter.offset = this.mData.tableRules.offset;
            }
            if (this.mData.tableRules.allowSorting) {
                dataFilter.sort = this.mData.tableRules.sort;
            }

            if (this.mData.tableRules.showUrl) {
                this.$router.replace({
                name: "Admin-" + this.mData.moduleName + "-list",
                query: {
                    limit: this.mData.tableRules.limit,
                    page: this.mData.tableRules.page,
                    sort: this.mData.tableRules.sort,
                    filters: this.mData.tableRules.filters,
                    showFormSearch: this.mData.tableRules.showFormSearch
                }
                }).catch(()=>{});
            }
            let listTestCertificateRes = await ForeignerQrApi.list(dataFilter);
            if(listTestCertificateRes.result && listTestCertificateRes.result.length > 0){
                this.haveNoData = false;
                let resData = await this.changeData(listTestCertificateRes.result);
                let foreignerIds = MethodService.findListItemDifferent(resData,"foreigner_id");
                // console.log("foreignerIds",foreignerIds);
                const reqForeignerApi = await ForeignerApi.list({
                    limit: foreignerIds.length,
                    filters: "id:in:" + foreignerIds.join(",") 
                });
                this.mData.dataDefault.listForeigner = reqForeignerApi.result;

                resData.forEach(item => {
                    let foreigner = this.mData.dataDefault.listForeigner.find(
                        element => {
                            return element.id == item.foreigner_id
                        }
                    )
                    if(foreigner){
                        item.anh_chan_dung_id = foreigner.anh_chan_dung_id;
                        item.ho_ten = foreigner.ho_chieu.ho_ten;
                        item.so_ho_chieu = foreigner.ho_chieu.so_ho_chieu;
                        let quocTichOb = this.mData.dataDefault.listQuocGia.find(e => e.id == foreigner.ho_chieu.quoc_tich_id);
                        item.quoc_tich = quocTichOb.ten_quoc_tich.vi; 
                    }
                });
                console.log("resData",resData);
                this.mData.data = resData;
                this.mData.tableRules.total = listTestCertificateRes.meta.total;
                this.mData.tableRules.page = listTestCertificateRes.meta.offset / listTestCertificateRes.meta.limit + 1;
                if (
                    this.mData.tableRules.offset == listTestCertificateRes.meta.total &&
                    this.mData.tableRules.offset != 0
                ) {
                    this.mData.tableRules.offset = 0;
                    this.mData.tableRules.page = 1;
                    this.fn_initTable();
                }
            }else{
                this.haveNoData = true;
            }
        },
        //xử lý dữ liệu đầu ra
        changeData(data) {
            return data;
        },
        fn_handle(type, row) {
            if (type == "approve") {
                this.$router.push({
                    name: "Admin-" + this.mData.moduleName + "-approve",
                    params: { id: row }
                });
            }
        },
         //event table
        fn_tableSizeChange(limit) {
        this.mData.tableRules.limit = limit;
        this.fn_tableChangeOffset(this.mData.tableRules.page);
        },
        fn_tableCurentChange(page) {
        this.fn_tableChangeOffset(page);
        },
        fn_tablePrevClick(page) {
        this.fn_tableChangeOffset(page);
        },
        fn_tableNextClick(page) {
        this.fn_tableChangeOffset(page);
        },

        fn_tableChangeOffset(page) {
        this.mData.tableRules.page = page;
        this.mData.tableRules.offset =
            (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        this.fn_initData();
        },
        fn_tableShowFormSearch() {
            this.mData.tableRules.showFormSearch = !this.mData.tableRules
                .showFormSearch;
            let query = Object.assign({}, this.$route.query);
            query.showFormSearch = this.mData.tableRules.showFormSearch;
            this.$router.push({
                name: "Admin-" + this.mData.moduleName + "-list",
                query: query
            });
        },
         fn_tableSearch() {
            this.$refs["myForm"].validate(async valid => {
                if (valid) {
                    this.mData.tableRules.filtersForeigner = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
                    let filterForeigner = {
                        limit: 1000,
                        filters : this.mData.tableRules.filtersForeigner
                    }
                    let foreignerApiRes = await ForeignerApi.list(filterForeigner);
                    if(foreignerApiRes.result && foreignerApiRes.result.length > 0){
                        console.log("foreignerApiRes.result",foreignerApiRes.result);
                    }
                    this.mData.tableRules.offset = 0;
                    this.mData.tableRules.sort = "";
                    this.fn_initData();
                } else {
                    MethodService.stopLadda();
                    return false;
                }
            });
        },
    },
    async mounted() {
        this.fn_initData();
    },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap');
p{
    margin-bottom: 0;
}
.main-card-header{
  position: fixed;
  top: 60px;
  width: 100%;
  height: 43px;
  z-index : 3;
  background-color: #cdf3f8;
  border-color: #cdf3f8;
  display: flex;
  align-items: center;
}
.main-card-header span{
  font-family: MYRIADPRO-REGULAR;
  color: #0c66ad;
  font-weight: 600;
}
.main-card-body{
  position: relative;
  top: 43px;
  min-height: calc(100vh - 128px);
}
::v-deep .el-collapse-item__wrap{
    position: relative;
}
::v-deep .el-collapse-item__header {
    height: 40px;
    color: #0c66ad;
    font-family: MYRIADPRO-REGULAR;
    font-weight: 600;
    font-size: 15px;
}

::v-deep .el-collapse-item__arrow{
    font-weight: 1000;
}

.title-list{
    font-size: 16px;
    font-weight: 500;
}

.infomation{
    font-size: 14px;
    font-weight: 400;
}

@media (max-width: 1650px) {
    
}

@media (max-width: 1300px) {
    
}

@media (max-width: 990px) {
    
}

@media (max-width: 1015px) {}

@media (max-width: 1120px) {}

@media (max-width: 767px) {}

@media (max-width: 670px) {
  
}

@media (max-width: 650px) {
    
}

@media (max-width: 500px) {
    
}

@media (max-width: 448px) {
  
}

@media (max-width: 400px) {
    
}

@media (max-width: 310px) {
    
}

@media (max-width: 390px) {
  
}
</style>